import React from "react";
import Loader from "../../../component/loader";

const Question = React.memo((props) => {
  return (
    <li className="d_flex mb_15" id={props.id}>
      <div className="like">
        <div className="count_like d_flex d_flex_align_center d_flex_justify_center relative">
          {props.totalLikes}
          <span className="thumb_count">
            <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M2 17.4272H3V5.50333H2C1.46957 5.50333 0.960859 5.6966 0.585786 6.04063C0.210714 6.38465 0 6.85125 0 7.33778V15.5928C0 16.0793 0.210714 16.5459 0.585786 16.8899C0.960859 17.2339 1.46957 17.4272 2 17.4272ZM18 5.50333H11L12.122 2.41413C12.2221 2.13842 12.2494 1.84485 12.2016 1.55759C12.1538 1.27032 12.0322 0.997583 11.847 0.76184C11.6617 0.526096 11.4181 0.334091 11.1361 0.201638C10.8541 0.0691855 10.5418 7.53156e-05 10.225 0H10L5 4.98785V17.4272H16L19.912 9.54278L20 9.17222V7.33778C20 6.85125 19.7893 6.38465 19.4142 6.04063C19.0391 5.6966 18.5304 5.50333 18 5.50333Z"
                  fill="white" />
            </svg>
        </span>
        </div>
      </div>
      <div className="qa_question">
        <p><strong className={props.isModerator ? 'error' : ''}>{props.senderName}:</strong> {props.question}</p>
      </div>
      <div className="d_flex d_flex_align_center relative">
        <div className="">
          <div className="check_que">
            <input type="checkbox" id={props.id} checked={props.isChecked} onChange={(e) => props.check(e)} />
            <label htmlFor={props.id}></label>
          </div>
        </div>
        <span className="pointer" onClick={() => props.delete()}>
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.41683 5.5V2.75C6.41683 2.50689 6.51341 2.27373 6.68532 2.10182C6.85722 1.92991 7.09038 1.83334 7.3335 1.83334H14.6668C14.9099 1.83334 15.1431 1.92991 15.315 2.10182C15.4869 2.27373 15.5835 2.50689 15.5835 2.75V5.5H20.1668V7.33334H18.3335V19.25C18.3335 19.4931 18.2369 19.7263 18.065 19.8982C17.8931 20.0701 17.6599 20.1667 17.4168 20.1667H4.5835C4.34038 20.1667 4.10722 20.0701 3.93532 19.8982C3.76341 19.7263 3.66683 19.4931 3.66683 19.25V7.33334H1.8335V5.5H6.41683ZM8.25016 3.66667V5.5H13.7502V3.66667H8.25016Z"
              fill="white" />
            </svg>
        </span>
        {props.loaderFlag && <Loader />}
      </div>
    </li>
  );
});

Question.propTypes = {};

export default Question;